import axios from 'axios';
import { useMemo } from 'react';

export const useConfig = () => {
  const baseURL = useMemo(() => {
    const webUrl = window.location.hostname;
    if (webUrl === 'localhost') {
      const env = process.env.REACT_APP_ENV;
      if (!env || env === 'local') {
        // No REACT_APP_ENV (or 'local'): talk directly to the backend
        // running on your machine (npm run local / mac / dev in CBP-Backend).
        return process.env.REACT_APP_API_URL || 'http://localhost:7001/';
      }
      // dev / stg / uat / prod: relative path, proxied by src/setupProxy.js
      // to the matching remote backend. Empty string (not '/') so
      // `${baseURL}/${path}` produces a root-relative URL ('/path') instead
      // of a protocol-relative one ('//path', read as a bogus host).
      return '';
    } else if (webUrl === 'cbp.netlify.app') {
      return 'https://cbp-dev.azul-arc.com/api';
    } else {
      return window.location.protocol + '//' + webUrl + '/api';
    }
  }, []);

  const apiInstance = axios.create({
    baseURL,
    timeout: 20000,
    headers: { 'Content-Type': 'application/json' },
  });

  return { apiInstance, baseURL };
};
